namespace GeniuzPOS.PosShift {
    export namespace LookupPostrandtsaleService {
        export const baseUrl = 'PosShift/LookupPostrandtsale';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LookupPostrandtsaleRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LookupPostrandtsaleRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "PosShift/LookupPostrandtsale/Retrieve",
            List = "PosShift/LookupPostrandtsale/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>LookupPostrandtsaleService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
